import { render } from "./PublicFooter.vue?vue&type=template&id=859b7e22&scoped=true"
import script from "./PublicFooter.vue?vue&type=script&lang=js"
export * from "./PublicFooter.vue?vue&type=script&lang=js"

import "./PublicFooter.vue?vue&type=style&index=0&id=859b7e22&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-859b7e22"]])

export default __exports__